import { Button, Form, Modal } from "react-bootstrap";
import { withTranslation } from "react-i18next";

const UomFormModal = ({ t, show, onHide, isAdd, form, errors, onChange, onSave }) => {
	return (
		<Modal show={show} onHide={onHide} centered>
			<Modal.Header closeButton>
				<Modal.Title>
					{isAdd ? (t("Uom.modal.add.title") || "Add UOM") : (t("Uom.modal.edit.title") || "Edit UOM")}
				</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<Form>
					<Form.Group className="mb-3">
						<Form.Label>{t("Uom.form.inputUnitName.label") || "Input Unit Name"} <span className="text-danger">*</span></Form.Label>
						<Form.Control
							type="text"
							value={form.inputUnitName}
							onChange={(e) => onChange("inputUnitName", e.target.value)}
							className={errors.inputUnitName ? "border border-danger" : ""}
						/>
					</Form.Group>
					<Form.Group className="mb-3">
						<Form.Label>{t("Uom.form.inputUnitCode.label") || "Input Unit Code"} <span className="text-danger">*</span></Form.Label>
						<Form.Control
							type="text"
							value={form.inputUnit}
							onChange={(e) => onChange("inputUnit", e.target.value)}
							className={errors.inputUnit ? "border border-danger" : ""}
							disabled={!isAdd}
						/>
					</Form.Group>
					<Form.Group className="mb-3">
						<Form.Label>{t("Uom.form.outputUnitName.label") || "Output Unit Name"} <span className="text-danger">*</span></Form.Label>
						<Form.Control
							type="text"
							value={form.outputUnitName}
							onChange={(e) => onChange("outputUnitName", e.target.value)}
							className={errors.outputUnitName ? "border border-danger" : ""}
						/>
					</Form.Group>
					<Form.Group className="mb-3">
						<Form.Label>{t("Uom.form.outputUnitCode.label") || "Output Unit Code"} <span className="text-danger">*</span></Form.Label>
						<Form.Control
							type="text"
							value={form.outputUnit}
							onChange={(e) => onChange("outputUnit", e.target.value)}
							className={errors.outputUnit ? "border border-danger" : ""}
							disabled={!isAdd}
						/>
					</Form.Group>
					<Form.Group className="mb-3">
						<Form.Label>{t("Uom.form.conversionFactor.label") || "Conversion Factor"} <span className="text-danger">*</span></Form.Label>
						<Form.Control
							type="number"
							step="0.0001"
							value={form.multiple}
							onChange={(e) => onChange("multiple", e.target.value)}
							className={errors.multiple ? "border border-danger" : ""}
						/>
					</Form.Group>
					<Form.Group className="mb-0">
						<Form.Label>{t("Geography.label") || "Geography"}</Form.Label>
						<Form.Control
							type="text"
							value={form.geography}
							onChange={(e) => onChange("geography", e.target.value)}
						/>
					</Form.Group>
				</Form>
			</Modal.Body>
			<Modal.Footer>
				<Button variant="secondary" onClick={onHide}>
					{t("Cancel.label")}
				</Button>
				<Button variant="primary" onClick={onSave}>
					{t("Save.label")}
				</Button>
			</Modal.Footer>
		</Modal>
	);
};

export default withTranslation()(UomFormModal);

